/*
 *
 * File JS componente timeline filters
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./timeline-filters.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const timelineFilters = () => {
    let allTimelineFilters = document.querySelectorAll(".timeline-filters");

    if (!allTimelineFilters.length) return;

    allTimelineFilters.forEach((el, i) => {
        const btn = el.querySelector(".timeline-filters__btn");
        const menu = el.querySelector(".timeline-filters__menu");

        btn.addEventListener("click", function (evt) {
            evt.preventDefault();
            menu.classList.toggle("open");
        });
    });
};

export default timelineFilters;

//--------------------------------------------------------------------//
